import styled from 'styled-components';
import { rem } from 'polished';
import { themed, colors } from 'core/theme';
import { Flex, FlexItem, media } from 'core/layout';

const color = (props) => themed(Object.assign({}, colors.darkThemed, {
  light: colors.B38,
}));

export const StyledFooter = styled.footer`
  color: ${color};
  font-size: ${rem(14)};
  margin-top: 4rem;
  padding-bottom: 2em;

  ${media.tablet`
    margin-top: 2rem;
    padding-bottom: 1em;
  `};

  ${media.tabletSmall`
    padding-bottom: 4em;
  `};

  @media print {
    display: none;
  }
`;

export const ScrollToTop = styled.div`
  font-size: ${rem(16)};
  text-align: right;
`;

export const InfoContainer = Flex.extend`
  flex-wrap: wrap;
  margin-top: 1.5em !important;
  margin-bottom: 1.5em !important;

  ${media.tabletSmall`
    display: flex;
  `};

  @media (max-width: 500px) {
    display: block;
  }

  ${media.mobile`
    display: block;
    margin: 0 0 1.25em 0 !important;
    width: 100%;

    & > * {
      padding-left: 0;
    }
  `};
`;

export const BottomContainer = Flex.extend`
  align-items: center;
  justify-content: space-between;
  margin-top: 1em !important;
  margin-bottom: 0;

  & > * {
    padding-top: 0;
  }
`;

export const LogoGroup = FlexItem.extend`
  display: flex;
  align-items: center;
  margin-top: 0;
  margin-bottom: 0;

  & > *:first-child {
    margin-right: 1.5em;
  }

  & > i:not(:first-child) {
    margin-right: 0.25em;
  }

  ${media.tablet`
    margin-top: 2em;
    margin-bottom: 1em;
  `};
`;

export const SocialGroup = FlexItem.extend`
  display: flex;
  justify-content: flex-end;
`;



// WEBPACK FOOTER //
// ./src/modules/Footer/styled.js